export default "__VITE_ASSET__ebdedef7__"